import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { AuthService } from './auth.service';

/** Routes de l'API accessibles sans jeton. */
const PUBLIC = ['/api/info'];

/** Ajoute le jeton Keycloak aux appels de l'API (sauf routes publiques et mode Development). */
export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const path = new URL(request.url, location.origin).pathname;
  if (!path.startsWith('/api/') || PUBLIC.includes(path)) {
    return next(request);
  }
  const auth = inject(AuthService);
  return from(auth.getAccessToken()).pipe(
    switchMap((token) =>
      next(token ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : request),
    ),
  );
};
